export default __webpack_public_path__ + "img/3eee4f58f87b1a19915c886e14489e91.png";